import { generateRandomId } from '@/utils/transactionUtils'

export interface KemCardInfo {
  id: string
  title: string
  value: string
}

// Fee data - hardcoded for now, could be fetched from API in the future
export const formatKemCardInfos = (
  t: (key: string) => string,
): KemCardInfo[] => [
  {
    id: generateRandomId(),
    title: t('translation:monthlyFee'),
    value: '$0.00',
  },
  {
    id: generateRandomId(),
    title: t('translation:perPurchaseFee'),
    value: '1%',
  },
  {
    id: generateRandomId(),
    title: t('translation:foreignTransactionFee'),
    value: '1.5%',
  },
  {
    id: generateRandomId(),
    title: t('translation:atmWithdrawFee'),
    value: '2.5% (Min $2.5)',
  },
  {
    id: generateRandomId(),
    title: t('translation:customerService'),
    value: '$0.00',
  },
  {
    id: generateRandomId(),
    title: t('translation:inactivity'),
    value: '$0.00',
  },
  {
    id: generateRandomId(),
    title: t('translation:activationFee'),
    value: '$0.00',
  },
]
